import { Vue } from "vue-property-decorator";

export interface ICommonComponentsContainable {
  getCommonComponentsContainer(): Vue;
}

export function instanceOfICommonComponentsContainable(instance: any): instance is ICommonComponentsContainable {
  return instance
    && (instance.getCommonComponentsContainer !== undefined);
}
